import React from "react";
import { Tooltip } from "antd";

import Question from "../../newUXAssets/icons/Question";
import { Row, StyledSwitch, LabelText, TooltipIcon } from "./styles";

const TOOLTIP_STYLE = { borderRadius: 6 };

const ToggleSwitch = ({ checked, onChange, label, tooltip, disabled = false }) => (
  <Row>
    <StyledSwitch checked={checked} onChange={onChange} disabled={disabled} />
    <LabelText>{label}</LabelText>
    {tooltip && (
      <Tooltip title={tooltip} overlayInnerStyle={TOOLTIP_STYLE}>
        <TooltipIcon>
          <Question size={16} color="rgba(0, 0, 0, 0.45)" />
        </TooltipIcon>
      </Tooltip>
    )}
  </Row>
);

export default ToggleSwitch;
